<template>
    <div class="not-found-view">
        <div class="left">
            <h1>
                <span>Oops!</span>
                404
            </h1>
            <p>The page you are looking for is missing.</p>
            <router-link :to="{ name: 'palettes' }">Home</router-link>
        </div>

        <div class="right">
            <div class="squares">
                <div class="square"></div>
                <div class="square"></div>
                <div class="square"></div>
                <div class="square"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Transition from "../../Lib/Objects/Transition";
    
    export default {
        name: "NotFound",

        mounted() {
            new Transition('.not-found-view', 0.5).fadeIn();
        },

        beforeDestroy() {
            new Transition('.not-found-view', 0.5).fadeOut();
        }
    }
</script>